import React from "react";
import { Button, Grid, SvgIcon, Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';
import {globalTheme} from './Theme'

const useStyles = makeStyles((theme) => ({
    button: {
        //background: 'linear-gradient(45deg, #5B5D61 50%,rgb(218, 232, 248) 85%)',
        background: 'linear-gradient(45deg,rgba(155,155,155, 0.25) 50%,rgba(227, 234, 241, 0.93) 80%)',
        width:"100%",
        minHeight: "105px",
    },
    svgIcon: {
        // height: "40px",
        // width: "45px",
        //display: "flex",
        width: "100%",
        height: "100%",
        fill: "inherit",
        // stroke:"white",
        // strokeOpacity: "50%",
        // strokeWidth:"20px"
    },
    iconGrid: {
      padding: "5px",
      width: "50%"
    },
    iconContainer: {
      height: "40px",
      width: "45px",
    },
    backgroundImg: {
        objectFit: "cover",
        pointerEvents: "none",
        position: "absolute",
        width: "100%",
        height: "100%",
        opacity: "0.1",
        mixBlendMode: "overlay"
    },
    projectTitle: {
        fontWeight: 600,
        textAlign: "left",
        color: "rgb(218, 232, 248)"
    },
    projectSummary: {
        fontWeight: 100,
        textTransform: "none",
        textAlign: "left",
        color: "rgb(218, 232, 248)"
    }
  }));

export default function ProjectTimelineButton(props) {
    const classes = useStyles(globalTheme);

    return (
        <Button 
            className={classes.button}
            color="secondary"
            onClick={props.changeRoute}
        >
            <img src={props.project[1].thumbnail} className={classes.backgroundImg} alt={props.project[0].key + "_thumbnail"}/>

            <Grid
                container
                direction="column"
            >
                <Typography variant="h5" className={classes.projectTitle}>
                    {props.project[0].projName}
                </Typography>
                <Typography variant="subtitle2"  className={classes.projectSummary}>
                    {props.project[0].summary}
                </Typography>
            </Grid>

            <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                className={classes.iconGrid}>
                {
                    props.project[0].technologies.map(
                    (technology)=>(
                            technology.icon != null &&
                            <Grid item className={classes.iconContainer} key={technology.text}>
                                <SvgIcon className={classes.svgIcon} key={technology.text + "Icon"}>
                                {
                                    technology.icon
                                }
                                </SvgIcon>
                            </Grid>
                        )
                    )
                }
            </Grid>
        </Button>
    );
}
